import useLocalStorage from '../../hooks/useLocalStorage'

const trackQuery = (item) => {
  if(!item || item === null || item === '') {
    return ''
  }

  const queryString = useLocalStorage('get', item)
  if(!queryString || queryString === null) {
    return ''
  }

  const result = parseQuery(queryString)
  const medium = result.utm_medium && result.utm_medium !== null ? result.utm_medium : 'direct'
  return {medium, result}
}

export default trackQuery

function parseQuery(queryString) {
  let query = {}
  let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&')
  for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=')
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return query
}